var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.501 23.334a9.333 9.333 0 1 0 0-18.666 9.333 9.333 0 0 0 0 18.666Zm0 2.333C8.058 25.667 2.835 20.444 2.835 14c0-6.443 5.223-11.666 11.666-11.666 6.444 0 11.667 5.223 11.667 11.666 0 6.444-5.223 11.667-11.667 11.667Zm-3.628-10.302-2.914-.909c-.63-.192-.634-.626.14-.938l11.356-4.386c.658-.269 1.034.07.82.921l-1.934 9.124c-.136.65-.527.805-1.069.505l-2.976-2.203-1.387 1.34c-.143.137-.258.255-.478.284-.218.03-.397-.035-.53-.397l-1.014-3.349-.014.008Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.cb18f5586198f9bad36dff031d681518.svg";
export { ForwardRef as ReactComponent };